import React from 'react';
import { Helmet } from 'react-helmet';
import useToggle from '../../../Hooks/useToggle';
import pageBanner from '../../../assets/images/inventory-banner.webp';
import inventoryImg1 from '../../../assets/images/inventory-dashboard.jpg';
import inventoryImg2 from '../../../assets/images/inventory-report.jpg';
import BackToTop from '../../BackToTop';
import FooterHomeThree from '../../Footer/FooterHomeThree';
import HeaderNews from '../../Header/HeaderNews';
import HeroNews from '../../Header/HeroNews';
import Drawer from '../../Mobile/Drawer';
import PreviewSlider from '../../PreviewSlider';
import ServicesAbout from './ServicesAbout';
import ShowCase from './ShowCase';

function Inventory() {
    const [drawer, drawerAction] = useToggle(false);
    return (
        <>
            <Helmet>
                <meta
                    name="description"
                    content="OTO offers cutting-edge inventory management software to optimize your supply chain, streamline operations, and increase efficiency. Simplify inventory tracking, procurement, and reporting with our innovative solutions in Kigali, Rwanda. Contact us for a demo!"
                />
                <title>Inventory Management with OTO Software | Kigali, Rwanda</title>
            </Helmet>
            <Drawer drawer={drawer} action={drawerAction.toggle} />
            <HeaderNews action={drawerAction.toggle} />
            <HeroNews
                title="Inventory Management"
                breadcrumb={[
                    { link: '/', title: 'Home' },
                    { link: '/apps', title: 'Apps' },
                    { link: '/apps/inventory-management', title: 'Inventory Management' },
                ]}
            />

            <div className="container pt-90 pb-90" style={{ fontSize: '18px', lineHeight: '29px' }}>
                <h3 className="mb-4">Inventory Management</h3>

                <p className="mb-3">
                    We understand the challenges that come with inventory management. That's why
                    we've designed OTO Inventory to be user-friendly, customizable, and efficient.
                    With our software, you can simplify your inventory management tasks, increase
                    your efficiency and profitability, and improve your overall business operations.
                </p>

                <p>
                    Our software provides you with real-time updates on your stock levels and
                    automating the reordering process to ensure you never run out of stock.
                </p>

                <img
                    className="page-banner-img mt-4"
                    src={pageBanner}
                    alt="OTO Inventory Software"
                />
            </div>

            <ServicesAbout />

            <ShowCase />
            <div className="container">
                <PreviewSlider
                    images={[
                        { url: inventoryImg1, alt: 'Inventory' },
                        { url: inventoryImg2, alt: 'OTO Inventory' },
                    ]}
                />
            </div>
            <div className="container pt-60 pb-80 text-center">
                <div className="mx-auto" style={{ maxWidth: '800px' }}>
                    <p className="mb-3">
                        Our Inventory Management software can help you optimize your inventory
                        management processes, save time and money, and make informed decisions about
                        purchasing and inventory management. Contact us today to learn more about
                        how our software can help your business.
                    </p>
                </div>
            </div>
            <FooterHomeThree className="appie-footer-about-area" />
            <BackToTop />
        </>
    );
}

export default Inventory;
